import { login, profile } from 'api';

interface IUserLoginData {
  access_token: string;
  expires_in: number;
  token_type: string;
  refresh_token: string;
  first_login: boolean;
}

export interface VerifyInviteExistsResponse {
  exists: boolean;
}

const parsedUserLoginData = ({ access_token, token_type, expires_in, refresh_token, first_login }: IUserLoginData) => ({
  accessToken: access_token,
  tokenType: token_type,
  expiresIn: expires_in,
  refreshToken: refresh_token,
  firstLogin: first_login,
});

export const handleLoginEmail = async (username: string, password: string) => {
  const user = {
    username,
    password,
    scope: 'all',
  };

  const response = await login.post<IUserLoginData>('/', { ...user });

  return parsedUserLoginData(response.data);
};

export const verifyInviteExists = (email: string) =>
  profile.get(`/Invite/VerifyInviteExists/${email}`).then((response) => response.data);

export const resendInvite = (email: string) => profile.post('/Invite/SentInvite', { email });
